import React, { useState, useEffect } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const EditCompanySettingsDrawer = ({
  isOpen,
  onClose,
  company,
  onUpdate,
}) => {
  const [formData, setFormData] = useState({
    company_name: "",
    vat_number: "",
    vat_percent: "",
    base_cost_per_delivery: "", 
    mogoma_commission_percent: "",
    driver_partner_commission_percent: "",
    postal_address: "",
    business_address: "",
    phone: "",
    email: "",
    currency: "BWP",
  });

  useEffect(() => {
    if (company) {
      setFormData({
        company_name: company.company_name || "",
        vat_number: company.vat_number || "",
        vat_percent: company.vat_percent ?? "",
        base_cost_per_delivery: company.base_cost_per_delivery ?? "",
        mogoma_commission_percent:
          company.mogoma_commission_percent ?? "",
        driver_partner_commission_percent:
          company.driver_partner_commission_percent ?? "",
        postal_address: company.postal_address || "",
        business_address: company.business_address || "",
        phone: company.phone || "",
        email: company.email || "",
        currency: company.currency || "BWP",
      });
    }
  }, [company]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    onUpdate({
      ...company,
      ...formData,
      vat_percent: Number(formData.vat_percent),
      base_cost_per_delivery: Number(
        formData.base_cost_per_delivery
      ),
      mogoma_commission_percent: Number(
        formData.mogoma_commission_percent
      ),
      driver_partner_commission_percent: Number(
        formData.driver_partner_commission_percent
      ),
    });
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Edit Company Settings</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Company Name"
            name="company_name"
            value={formData.company_name}
            onChange={handleChange}
            placeholder="Enter company name"
          />

          <ReusableInput
            label="VAT Number"
            name="vat_number"
            value={formData.vat_number}
            onChange={handleChange}
            placeholder="Enter VAT number"
          />

          <ReusableInput
            label="VAT Percentage"
            name="vat_percent"
            type="number"
            value={formData.vat_percent}
            onChange={handleChange}
            placeholder="Enter VAT percentage"
          />

          <ReusableInput
            label="Base Cost Per Delivery"
            name="base_cost_per_delivery"
            type="number"
            value={formData.base_cost_per_delivery}
            onChange={handleChange}
            placeholder="Enter base cost per delivery"
          />
          <ReusableInput
            label="Mogoma Commission (%)"
            name="mogoma_commission_percent"
            type="number"
            value={formData.mogoma_commission_percent}
            onChange={handleChange}
            placeholder="Enter Mogoma commission percentage"
          />

          <ReusableInput
            label="Driver Partner Commission (%)"
            name="driver_partner_commission_percent"
            type="number"
            value={formData.driver_partner_commission_percent}
            onChange={handleChange}
            placeholder="Enter driver partner commission percentage"
          />
          <ReusableInput
            label="Postal Address"
            name="postal_address"
            value={formData.postal_address}
            onChange={handleChange}
            placeholder="Enter postal address"
          />

          <ReusableInput
            label="Business Address"
            name="business_address"
            value={formData.business_address}
            onChange={handleChange}
            placeholder="Enter business address"
          />

          <ReusableInput
            label="Phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter phone number"
          />

          <ReusableInput
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter email address"
          />

          <ReusableInput
            label="Currency"
            name="currency"
            value={formData.currency}
            onChange={handleChange}
            placeholder="e.g. BWP"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} width="100px" height="40px">
            Cancel
          </GradientButton>

          <GradientButton onClick={handleSubmit} width="100px" height="40px">
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditCompanySettingsDrawer;
